import request from '@/api/request'
import download from '@/api/download'

// 
export function add(data) {
  return request({
      url: '/market-service/epc/construction/securityAccident/save',
      method: 'post',
      data
  })
}

export function edit(data) {
  return request({
      url: '/market-service/epc/construction/securityAccident/modify',
      method: 'post',
      data,
  })
}

export function fetchDetail(params) {
  return request({
      url: `/market-service/epc/construction/securityAccident/query/${params.id}`,
  })
}

// 下载模版
export function downloadTemplate(params) {
  return download({
      url: `/market-service/epc/construction/securityAccident/export/template?fileExportType=${params}`,
  })
}
// 导出
export function exportFile(data) {
  return download({
      url: `/market-service/epc/construction/securityAccident/export`,
      data
  })
}

